module.exports = __webpack_public_path__ + "img/tab32.f48c4fa8.png";